import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_2 = { class: "breadcrumb-item active" }

import Page from '@/components/page/page.vue';
import CustomersDevicesList from '@/modules/customers-devices/customers-devices-list.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, {
    title: _ctx.$t('areas.customersDevices.title')
  }, {
    breadcumbsItems: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("li", _hoisted_2, _toDisplayString(_ctx.$t('areas.customersDevices.title')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(CustomersDevicesList)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})